import moment from 'moment';
import { View, Text, Image } from '@react-pdf/renderer';
import { styles } from './styles';
import certificated from '../../../assets/certificated.png';

interface SignatureProps {
  professional_name?: string;
  signer_name?: string;
  terminology_code?: string;
  terminology_description?: string;
  rqe?: string;
  signature?: string | null;
  validation_code?: string | null;
  signed_at?: string | null;
  separate_page_when_signed?: boolean;
  clinic?: string | null;
}

export const RSignature: React.FC<SignatureProps> = ({
  professional_name,
  signer_name,
  terminology_code,
  terminology_description,
  rqe,
  signature,
  validation_code,
  signed_at,
  separate_page_when_signed,
  clinic,
}) => {
  const {
    containerSignature,
    digitalSignatureContainer,
    digitalSignatureLeft,
    digitalSignatureRight,
    digitalSignatureCertificate,
    digitalSignatureBadge,
    digitalSignatureBadgeText,
    digitalSignatureTitle,
    digitalSignatureSigner,
    digitalSignatureMeta,
    digitalSignatureValidationCode,
    digitalSignatureTimestamp,
    digitalSignatureImage,
    rowContainer,
    signatureText,
    terminologyText,
    rqeText,
    validationCodeText,
    digitalSignatureValidationUrl,
    validationUrlText,
  } = styles;

  const hasDigitalSignature = Boolean(
    validation_code || signed_at || signature,
  );
  const shouldBreakPage = Boolean(
    hasDigitalSignature && separate_page_when_signed,
  );

  const signerDetails = [
    terminology_description,
    terminology_code,
    rqe ? `RQE ${rqe}` : null,
  ]
    .filter(Boolean)
    .join(' | ');

  const formattedSignedAt = signed_at
    ? moment(signed_at).format('DD/MM/YYYY HH:mm:ss')
    : null;

  const renderTerminology = () => {
    if (terminology_description && terminology_code) {
      return (
        <Text style={terminologyText}>
          {terminology_description} {terminology_code}
        </Text>
      );
    }
  };

  const renderRqe = () => rqe && <Text style={rqeText}>RQE {rqe}</Text>;

  const frontendUrl =
    process.env.REACT_APP_FRONTEND_URL || 'https://sigeclin.com';
  const validationUrl = `${frontendUrl}/validate-signature`;

  return (
    <>
      {shouldBreakPage ? <View break /> : null}
      <View style={containerSignature} wrap={false}>
        {hasDigitalSignature ? (
          <View style={digitalSignatureContainer}>
            <View style={digitalSignatureLeft}>
              <Image src={certificated} style={digitalSignatureCertificate} />
              <Text style={digitalSignatureBadge}>ASSINADO DIGITALMENTE</Text>
              {signature ? (
                <Image src={signature} style={digitalSignatureImage} />
              ) : null}
              <Text style={digitalSignatureBadgeText}>
                Documento com autenticidade verificavel
              </Text>
            </View>

            <View style={digitalSignatureRight}>
              <Text style={digitalSignatureTitle}>
                Assinado digitalmente por
              </Text>
              <Text style={digitalSignatureSigner}>
                {signer_name ||
                  professional_name ||
                  'Profissional nao informado'}
              </Text>
              <Text style={digitalSignatureMeta}>
                Cód. Organização: {clinic || 'N/A'}
              </Text>
              {signerDetails ? (
                <Text style={digitalSignatureMeta}>{signerDetails}</Text>
              ) : null}
              {validation_code ? (
                <View>
                  <Text style={digitalSignatureValidationCode}>
                    Codigo de validacao: {validation_code}
                  </Text>
                  <Text style={digitalSignatureValidationUrl}>
                    Verifique em {validationUrl}
                  </Text>
                </View>
              ) : null}
              {formattedSignedAt ? (
                <Text style={digitalSignatureTimestamp}>
                  Data da assinatura: {formattedSignedAt}
                </Text>
              ) : null}
            </View>
          </View>
        ) : null}

        {!hasDigitalSignature && signature && (
          <Image
            src={signature}
            style={{
              width: '30%',
              marginBottom: 0,
              marginLeft: 165,
              display: 'flex',
              justifyContent: 'center',
            }}
          />
        )}
        {!hasDigitalSignature && <View style={rowContainer} />}
        {!hasDigitalSignature && (
          <Text style={signatureText}>{signer_name || professional_name}</Text>
        )}
        {!hasDigitalSignature && renderTerminology()}
        {!hasDigitalSignature && renderRqe()}
        {!hasDigitalSignature && validation_code && (
          <View>
            <Text style={validationCodeText}>
              Codigo de validacao: {validation_code}
            </Text>
            <Text style={validationUrlText}>Verifique em {validationUrl}</Text>
          </View>
        )}
      </View>
    </>
  );
};
